// Client/ClientItem.tsx
import React, {useContext} from 'react';
import {Card, CardContent, IconButton, Typography, useMediaQuery} from '@mui/material';
import UserAvatar from "User/UserAvatar";
import ChatIcon from '@mui/icons-material/Chat';
import {axios} from "Auth/axiosConfig";
import {useNavigate} from 'react-router-dom';
import {AuthContext, AuthContextType} from "Auth/AuthContext";
import {useErrorProcessing} from "Core/components/ErrorProvider";
import {IUser} from "Types/core/user";
import {useTheme} from "Theme/ThemeContext";


interface ClientItemProps {
    client: IUser;
    onClick?: () => void;
}

const ClientItem: React.FC<ClientItemProps> = ({client, onClick}) => {
    const {byResponse} = useErrorProcessing();
    const navigate = useNavigate();
    const {user} = useContext(AuthContext) as AuthContextType;
    const {theme} = useTheme();
    const isMdOrSmaller = useMediaQuery(theme.breakpoints.down('md'));

    const handleChatClick = async (event: React.MouseEvent) => {
        if (!user) return;
        event.stopPropagation(); // Предотвращает вызов onClick карточки при клике на иконку чата
        try {
            const response = await axios.post('/api/v1/psych_client_init_room/', {
                name: `${user.id}-${client.id}`,
                participants: [user.id, client.id]
            });
            navigate(`/chats/room/${response.data.id}`);
        } catch (error) {
            byResponse(error);
        }
    };

    return (
        <Card
            onClick={onClick}
            className={`client-item ${isMdOrSmaller ? 'w-100' : ''} hover-scale-2 transition-all transition-d-300`}
        >
            <CardContent className={'p-3'}>
                <div className={'frsc gap-2 mb-2'}>
                    <UserAvatar avatar={client.avatar} size={'2.3rem'}/>
                    <Typography variant="h6">
                        {client.first_name} {client.last_name}
                    </Typography>
                    <IconButton onClick={handleChatClick}>
                        <ChatIcon/>
                    </IconButton>
                </div>
                <Typography variant="body2" color="textSecondary">
                    Запланировано: <span className={'fw-6'}>
                        {client.consultations_scheduled_count}
                    </span>
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    Завершено: <span className={'fw-6'}>
                        {client.consultations_completed_count}
                    </span>
                </Typography>
            </CardContent>
        </Card>
    );
};

export default ClientItem;
